export const SINGLE = 1;
export const EXPRESS = 2;
export const SYSTEM = 3;
export const ANTIEXPRESS = 5;



// WEBPACK FOOTER //
// ./js/constants/BetType.js